/**
 * Projection d'un point sur la polyligne à pas constant : O(n), sans Turf.
 * Retourne l'index du point de grille le plus proche — c'est tout ce dont on a
 * besoin puisqu'une gare est un index.
 */
export interface Snap {
  idx: number;
  /** distance au point de grille, m */
  dist_m: number;
}

const KY = 110540.0;

export function nearestIndex(coords: ArrayLike<[number, number]>, lon: number, lat: number): Snap {
  const kx = 111320.0 * Math.cos((lat * Math.PI) / 180);
  let best = Infinity;
  let bi = 0;
  for (let i = 0; i < coords.length; i++) {
    const c = coords[i];
    const dx = (c[0] - lon) * kx;
    const dy = (c[1] - lat) * KY;
    const d2 = dx * dx + dy * dy;
    if (d2 < best) {
      best = d2;
      bi = i;
    }
  }
  return { idx: bi, dist_m: Math.sqrt(best) };
}

/** Distance (m) entre deux points WGS84, plan local — suffisant à l'échelle d'une île. */
export function distanceM(a: [number, number], b: [number, number]): number {
  const kx = 111320.0 * Math.cos((((a[1] + b[1]) / 2) * Math.PI) / 180);
  const dx = (a[0] - b[0]) * kx;
  const dy = (a[1] - b[1]) * KY;
  return Math.sqrt(dx * dx + dy * dy);
}
